import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useHistory } from "react-router-dom";
import _ from "lodash";
import { appsflyer, appsflyerEventName } from "../../../utils/appsflyer";
import { useAlert, useAmplitude, useUserInfo } from "../../../hooks";
import useHackleInfo from "../../../hooks/useHackle";
import { getSubscribe, requestSubscribe } from "../../../utils/utilityEtc";
import HACKLE_DATA from "../../../constant/HACKLE_DATA";
import { TYPE, URL } from "../../../constant";

const SubscribeNew = () => {
  const [isOnBoarding, setIsOnBoarding] = useState(false);
  const [products, setProducts] = useState([]);
  const { info } = useUserInfo();

  const history = useHistory();
  const location = useLocation();
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const [Alert] = useAlert();
  const { setAmplitudeLog } = useAmplitude();
  const { setHackleLog } = useHackleInfo();

  // 해당 상품 스토어 정보
  const getSubscribeOfProduction = useCallback(async (productId) => {
    const subscribe = await getSubscribe(productId);
    return subscribe;
  }, []);

  // Back 버튼 클릭
  const handleBackBtn = useCallback(() => {
    history.goBack();
  }, []);

  // 구매 버튼 클릭
  const handlePurchaseBtn = useCallback(async (productInfo) => {
      if (
        process.env.REACT_APP_ENV === "development" ||
        process.env.REACT_APP_ENV === "local"
      ) {
        console.log("### productInfo", productInfo);
      }

      const { ID, CODE, SUBSCRIBE } = productInfo;
      let subScribe = null;

      // 구독 상품인 경우 예외처리
      if (SUBSCRIBE) {
        subScribe = await getSubscribeOfProduction(ID);

        // 플레이스토어 계정 'Y' 인경우
        if (_.isEqual(subScribe?.subscribing, "Y")) {
          Alert(
            `${
              language === "ko"
                ? "이미 결제된 Playstore ID 입니다.<br/>결제 시 사용했던 매쓰피드 ID로 로그인하시거나 Playstore에서 환불 후,<br/>앱을 다시 실행해주세요"
                : "Your Google Play ID is already subscribed to Mathpid Premium.<br/>Please login with the Mathpid ID(Email) you used to purchased the subscription.<br/>Or Refund at Google Play and restart the Mathpid app."
            }`
          );
          return null;
        }
      }

      const accessToken = localStorage.getItem("access.token");
      const { userId: mbrId = "" } = info;

      if (!_.isEmpty(mbrId) && !_.isEmpty(accessToken)) {
        if (
          process.env.REACT_APP_ENV === "development" ||
          process.env.REACT_APP_ENV === "local"
        ) {
          console.log("payment prductId : ", ID);
          console.log("payment mbrId : ", mbrId);
          console.log("payment accessToken : ", accessToken);
        }

        requestSubscribe(ID, mbrId, accessToken); // 결제요청
      } else {
        // 예외처리
        Alert(t("error.msg001"));
      }

      // 상품 구매화면 조회
      setAmplitudeLog({
        eventName: {
          name: "결제하기버튼클릭",
          event: {
            "소스화면": "",
            "상품 코드": CODE,
            "상품 명": ID,
          },
        },
      });
      setHackleEvent(productInfo?.i);
      appsflyer({
        eventName: appsflyerEventName.purchase_click,
        eventParams: null,
      });
    },
    [info, isOnBoarding]
  );

  const setHackleEvent = useCallback((index) => {
    if (isOnBoarding) {
      setHackleLog(`${HACKLE_DATA.TYPE[`PURCHASE_BTN_ONBADING_1_${index + 1}CLICK`]}`); // 결제 클릭(온보딩)
    } else {
      setHackleLog(`${HACKLE_DATA.TYPE[`PURCHASE_BTN_LEARNING_4_${index + 1}CLICk`]}`); // 결제 클릭
    }
  }, [isOnBoarding]);

  const setAmplitude = async () => {
    // 상품 구매화면 조회
    setAmplitudeLog({
      eventName: {
        name: "상품 구매화면 조회",
        event: {
          "소스화면": "",
          "상품 코드": "",
          "상품 명": "",
        },
      },
    });
  };

  React.useEffect(() => {
    // checked 온보딩 유무
    const { state } = location;
    if (state?.isOnBoarding) {
      setIsOnBoarding(state?.isOnBoarding);
      setHackleLog(HACKLE_DATA.TYPE.PURCHASE_PAGE_ONBOARDING_VIEW); // 화면 조회
    } else {
      setHackleLog(HACKLE_DATA.TYPE.PURCHASE_PAGE_LEARNING_VIEW); // 화면 조회
    }
  }, []);

  React.useEffect(() => {
    const tempArr = Object.values(TYPE.PAYMENT[info.countryCd].PRODUCT);
    setProducts(tempArr);
    setAmplitude();
  }, [info]);

  return (
    <div className="pay_wrap">
      <div className="layout-def layout-lc">
        <div className="header">
          <div className="inner">
            <div className="header_wrap">
              {/* <!-- 온보딩 직후일 경우에는 back 버튼 없음 --> */}
              {!isOnBoarding && (
                <button
                  type="button"
                  className="btn_back"
                  onClick={handleBackBtn}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/static/images/payment/btn_pay_back.png`}
                    alt="back"
                  />
                </button>
              )}

              <h1 className="logo">
                <img
                  src={`${process.env.PUBLIC_URL}/static/images/payment/logo_mathpid.svg`}
                  alt="Mathpid premium"
                />
              </h1>
            </div>
          </div>
        </div>
        {/* <!-- //header --> */}
        <div className="container">
          <div className="inner">
            <div className="centermiddleBox">
              <div className="centermiddleBox-row">
                {/* <!-- 컨텐츠 시작 --> */}
                <div className="pay_contents">
                  <h2 className="pay_title">
                    <img
                      src={`${process.env.PUBLIC_URL}/static/images/payment/tit_pay01.png`}
                      alt="Advanced personalized learning by AI Tutor"
                    />
                  </h2>
                  <div className="advan_area">
                    <div className="adv_list">
                      <ul>
                        <li>Silicon Valley Based AI Diagnosis</li>
                        <li>Customized Learning Course</li>
                        <li>UNLIMITED Problems!</li>
                        <li>20+ Math games coming soon!</li>
                        <li>and much more to be updated!</li>
                      </ul>
                    </div>
                    {/* <!-- // adv_list --> */}
                    <article className="key_article">
                      <table className="key_table">
                        <caption>Key Features</caption>
                        <colgroup>
                          <col style={{ width: "52%" }} />
                          <col span="2" style={{ width: "24%" }} />
                        </colgroup>
                        <thead>
                          <tr>
                            <th scope="col">
                              <div className="th_inner tit_key">
                                Key Features
                              </div>
                            </th>
                            <th scope="col">
                              <div className="th_inner tit_limit">Limited</div>
                            </th>
                            <th scope="col">
                              <div className="th_inner tit_prem">Premium</div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="highlight">
                            <td>
                              Free Topic
                              <br />
                              <span className="sub_txt">(Question Bank)</span>
                            </td>
                            <td>
                              <span className="ic_check">Checked</span>
                            </td>
                            <td>
                              <span className="ic_check">Checked</span>
                            </td>
                          </tr>
                          <tr className="highlight">
                            <td>
                              Math Camera
                              <br />
                              <span className="sub_txt">
                                (Picture &amp; Learn)
                              </span>
                            </td>
                            <td>
                              <span className="ic_check">Checked</span>
                            </td>
                            <td>
                              <span className="ic_check">Checked</span>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Silicon Valley
                              <br />
                              Based Diagnosis
                              <br />
                              <span className="sub_txt">(Unlimited Times)</span>
                            </td>
                            <td></td>
                            <td>
                              <span className="ic_check">Checked</span>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              My Course
                              <br />
                              <span className="sub_txt">
                                (Personalized AI Tutor)
                              </span>
                            </td>
                            <td></td>
                            <td>
                              <span className="ic_check">Checked</span>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              UNLIMITED
                              <br />
                              Problems
                            </td>
                            <td></td>
                            <td>
                              <span className="ic_check">Checked</span>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              20+ Math games
                              <br />
                              coming soon!
                            </td>
                            <td></td>
                            <td>
                              <span className="ic_check">Checked</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </article>
                    {/* <!-- // key_table --> */}
                  </div>

                  <h3 className="pay_title">
                    <img
                      src={`${process.env.PUBLIC_URL}/static/images/payment/tit_pay02.png`}
                      alt="Special Discount Offer in Every Plan"
                    />
                  </h3>
                  <article className="plan_list">
                    <ul>
                      {products.length > 0 &&
                        products.map((v, i) => {
                          const { TITLE, ID, CODE, BADGE, PRICE, SUBSCRIBE } =
                            v;

                          return (
                            <li className="plan_item" key={i}>
                              <dl className="plan_box">
                                <dt className="title_line">
                                  <strong className="tit">{TITLE}</strong>
                                  <div
                                    className={`badge ${
                                      BADGE.BEST ? "best" : ""
                                    }`}
                                  >
                                    {BADGE.BEST && <em className="in">BEST</em>}
                                    <span className="per">
                                      {BADGE.DISCOUNT_RATE}
                                    </span>
                                    <span className="txt">{BADGE.TEXT}</span>
                                  </div>
                                </dt>
                                <dd className="price_div">
                                  <span className="before">{PRICE.PREV}</span>
                                  <strong className="after">{PRICE.NOW}</strong>
                                </dd>
                                <dd className="btn_area">
                                  <a
                                    href="#"
                                    className="btn btn-navy"
                                    onClick={() =>
                                      handlePurchaseBtn({ ID, CODE, SUBSCRIBE, i })
                                    }
                                  >
                                    Buy Now!
                                  </a>
                                </dd>
                              </dl>
                            </li>
                          );
                        })}
                    </ul>
                  </article>
                  {/* <!-- 결제 페이지일 경우 삭제 --> */}
                  {isOnBoarding && (
                    <div className="btn_bottom_area">
                      <a
                        href="#"
                        className="btn_refuse"
                        onClick={() =>
                          history.push(URL.SELECT_LEARNING, {
                            prevPoint: "init_appLogin",
                          })
                        }
                      >
                        No, Thanks. Try it Free
                      </a>
                    </div>
                  )}

                  {/* <!--// 결제 페이지일 경우 삭제 --> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- //container --> */}
      </div>
      {/* <!-- //layout-def --> */}
    </div>
  );
};

export default SubscribeNew;
